import { MessageCircle, Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { telLink, waLink } from "@/lib/api";

export function FloatingActions() {
  const { settings } = useSite();
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3 no-print">
      <a
        href={telLink(settings.phone)}
        className="h-12 w-12 rounded-full grid place-items-center bg-[#1F1411] border border-[#D4AF37]/40 text-[#D4AF37] shadow-xl transition-transform duration-300 hover:-translate-y-1 md:hidden"
        aria-label="Hemen ara"
        data-testid="floating-call-btn"
      >
        <Phone size={20} />
      </a>
      <a
        href={waLink(settings.whatsapp, "Merhaba, Yeni Mercan Restoran hakkında bilgi almak istiyorum.")}
        target="_blank"
        rel="noopener noreferrer"
        className="h-14 w-14 rounded-full grid place-items-center bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,.6)] transition-transform duration-300 hover:-translate-y-1 hover:scale-105"
        aria-label="WhatsApp ile yazın"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle size={26} />
      </a>
    </div>
  );
}
